<template>
    <BaseCardCollection
        v-if="cards && cards.length"
        :cards="cards"
    />
    <p v-else>
        There are no
        <template v-if="isLiveEvents">events</template>
        <template v-else>education pages</template>
        related to this page right now.
        <nuxt-link
            v-if="isLiveEvents"
            to="/education-events/events"
        >
            See all events
        </nuxt-link>
        <nuxt-link
            v-else
            to="/education-events/education"
        >
            See all education pages
        </nuxt-link>
    </p>
</template>

<script setup>
import relatedLiveEventsQuery from '~/graphql/queries/events/relatedLive.graphql';
import relatedOnDemandEventsQuery from '~/graphql/queries/events/relatedOnDemand.graphql';
import useSrcSets from '~/utils/srcset';

const { getSrcSet } = useSrcSets();

const props = defineProps({
    relatedToEntryId: {
        type: [Number, String],
        required: false,
        default: null,
    },
    relatedToTagId: {
        type: [Number, String],
        required: false,
        default: null,
    },
    eventType: {
        type: String,
        required: false,
        default: 'live',
    },
});

const { variables } = useCraftVariables();

variables.limit = 3;

if (props.relatedToEntryId) {
    variables.relatedToEntries = [{ id: props.relatedToEntryId }];
}
if (props.relatedToTagId) {
    variables.relatedToTags = [{ id: props.relatedToTagId }];
}

const { data } = await useLazyAsyncQuery({
    query:
        props.eventType === 'live'
            ? relatedLiveEventsQuery
            : relatedOnDemandEventsQuery,
    variables,
});

const pillsCard = usePillsCard();
const eventsCard = useEventsCard();

const isLiveEvents = props.eventType === 'live';

const cards = computed(() => {
    const events = toValue(data)?.future;
    if (events) {
        return events.map((event) => {
            let image = null;
            if (event.image.length) {
                image = {
                    src: event.image?.[0]?.large,
                    srcset: getSrcSet(event.image?.[0]),
                };
            }
            return {
                image,
                title: event.title,
                meta: eventsCard.makeMeta(event),
                location: eventsCard.makeLocation(event),
                uri: event.uri,
                pills: pillsCard.getCardPills(event),
            };
        });
    }
    return null;
});
</script>
